import { useParams } from "react-router-dom"
import { AdUnits, Edit, Info, TableChart } from "@mui/icons-material"
import { useEffect, useState } from "react"
import { FetchFromBackoffice } from "../../utils/request"
import { EditReleaseNotes } from "./editReleaseNotesModal"
import Page from "../../components/molecules/page"
import React from "react";
import { EditVersionDescriptionModal } from "./editVersionDescriptionModal"
import { ReleaseNotes } from "./releaseNotes"
import { BOMTable } from "./bomTable"
import { HubsTable } from "./hubsTable"
import { DataLoadingText } from "../../components/atoms/text/dataLoadingText"
import { Typography } from "@mui/material"
import { BOMItem } from "../machines/assetHistory/assetHistory"


export const HardwareVersionPage = () => {
    const { versionId } = useParams();
    const [modalOpen, setModalOpen] = useState<boolean>(false)
    const [parts, setParts] = useState<BOMItem>()
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
    const [isLoadingNotes, setIsLoadingNotes] = useState<boolean>(true)



    useEffect(() => {
        const getVersionInfo = async (): Promise<BOMItem> => {
            setIsLoadingNotes(true)
            const parts = await FetchFromBackoffice(`hardware/${versionId}`) as BOMItem
            return parts
        }
        getVersionInfo().then(version => {
            if (version) {
                setParts(version)
                setIsLoadingNotes(false)
            }
        });
    }, [versionId]);

    return (
        <>
            {/*modalOpen && parts?.description && versionId &&
                <EditReleaseNotes
                    description={parts.description}
                    open={modalOpen}
                    closeModal={() => setModalOpen(false)}
                    onSaved={newText => setParts(curr => ({ ...curr!, description: newText ?? "" }))}
                    articleNo={versionId}
                />
            */}
            {/*editModalOpen && (
                <EditVersionDescriptionModal
                    open={editModalOpen}
                    versionId={versionId}
                    description={parts?.description}
                    closeModal={() => setEditModalOpen(false)}
                    onSaved={newText => setParts(curr => ({ ...curr!, articleName: newText ?? "" }))}
                />
            )*/}
            <Page
                title={versionId}
                /*Menu={{
                    Id: "machine-page-menu",
                    ButtonTitle: "Actions",
                    MenuItems: [
                        {
                            Label: "Edit description",
                            Icon: <Edit />,
                            onClick: () => setEditModalOpen(true),
                        }
                    ],
                }}*/
               description={parts?.description}
                tabs={[/*
                    {
                        name: "Overview",
                        icon: <Info />,
                        pageSections: [isLoadingNotes ? (
                                  <DataLoadingText showSpinner text={'Loading release notes...'} />
                                ): (<ReleaseNotes text={parts?.description ? parts.description : ""} onClick={() => setModalOpen(true)} />)],
                    },*/
                    {
                        name: "BOM",
                        icon: <TableChart />,
                        pageSections: [!parts ?  <Typography>No BOM for this version. </Typography> : <BOMTable parts={parts} />],
                    },
                    /* //removed for now since data is hardcoded
                    {
                        name: "Hubs",
                        icon: <AdUnits />,
                        pageSections: [<HubsTable />],
                    },*/
                ]}
            >
            </Page>
        </>
    )

}